import { fetchMediaLibraryItems } from '../../../../flows';
import { useMediaFetchService } from '../../services';

const useMediaLibraryItemsFetchService = (accountId, loadParams) =>
    useMediaFetchService({ accountId, fetch: fetchMediaLibraryItems, loadParams });

export default useMediaLibraryItemsFetchService;
